/** @jsx isolateComponent */

import { createContext, useContext, useEffect } from 'react';
import { useRouter } from 'next/router';

import { useLocalStorage } from '@zapier/common-hooks';
import { isolateComponent } from '@zapier/common-utils';

const CurrentAccountIdContext = createContext(undefined);

export const useCurrentAccountId = () => useContext(CurrentAccountIdContext);

type Props = {
  children: React.ReactNode;
};

export const CurrentAccountIdProvider = (props: Props) => {
  const [currentAccountId, setCurrentAccountId] = useLocalStorage(
    'currentAccountId'
  );
  const router = useRouter();
  const context = router?.query?.context as string | undefined;
  useEffect(() => {
    const accountIdFromQueryParam = context && parseInt(context, 10);
    const isDifferentAccountId = currentAccountId !== accountIdFromQueryParam;
    if (accountIdFromQueryParam && isDifferentAccountId) {
      setCurrentAccountId(accountIdFromQueryParam);
    }
  }, [context, currentAccountId, setCurrentAccountId]);
  return (
    <CurrentAccountIdContext.Provider value={currentAccountId}>
      {props.children}
    </CurrentAccountIdContext.Provider>
  );
};
